@let jobsCountValue = jobsCount();
@let bodyForCurrentStepValue = bodyForCurrentStep();
@let categoryOptionsValue = categoryOptions();
@let hasFooterValue = hasFooter();

<rt-dialog-header
  [heading]="'app.offers.manage_eeo.dialog.heading' | translate"
  [subheading]="'app.offers.manage_eeo.dialog.subheading' | translate: { count: jobsCountValue }"
>
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  <ng-container [ngTemplateOutlet]="bodyForCurrentStepValue"></ng-container>
</rt-dialog-body>
@if (hasFooterValue) {
  <rt-dialog-footer>
    <rt-button variant="plain" (click)="cancel()" margin-right-small>
      {{ 'app.common.cancel' | translate }}
    </rt-button>
    <rt-button variant="primary" [disabled]="categoryControl.invalid" (click)="save()">
      {{
        'app.offers.manage_eeo.confirm_enable.agree_label' | translate: { count: jobsCountValue }
      }}
    </rt-button>
  </rt-dialog-footer>
}

<ng-template #stepAction>
  <rt-new-item-button
    [heading]="'app.offers.manage_eeo.dialog.enable_eeo' | translate"
    [subheading]="'app.offers.manage_eeo.dialog.enable_eeo_description' | translate"
    [icon]="'check'"
    (click)="enable()"
  >
  </rt-new-item-button>
  <rt-new-item-button
    [heading]="'app.offers.manage_eeo.dialog.disable_eeo' | translate"
    [subheading]="'app.offers.manage_eeo.dialog.disable_eeo_description' | translate"
    [icon]="'remove-circle'"
    (click)="disable()"
    class="danger-on-hover"
    margin-top
  ></rt-new-item-button>
</ng-template>

<ng-template #stepCategory>
  <rt-form-field>
    <rt-label>{{ 'app.application_form.eeoc_category' | translate }}</rt-label>
    <rt-select
      [includeEmptyOption]="false"
      [options]="categoryOptionsValue"
      [placeholder]="'app.offers.manage_eeo.dialog.category_placeholder' | translate"
      [value]="categoryControl.value"
      (valueChange)="categoryControl.patchValue($event)"
    ></rt-select>
  </rt-form-field>
  <rt-infobox [isDismissible]="false" iconName="info-outline" margin-top>
    <p [innerHTML]="'app.offers.manage_eeo.dialog.infobox' | translate"></p>
  </rt-infobox>
</ng-template>
